module.exports = __webpack_public_path__ + "img/UPGPT.222a3fd7.png";